import { Plus, Trash2 } from 'lucide-react';
import { Input } from 'src/components/ui/input';
import { SchedulerDsButton } from 'src/pages/operations/components/scheduler-ds-button';

export interface StringListEditorProps {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  addLabel?: string;
  emptyMessage?: string;
}

export function StringListEditor({
  label,
  values,
  onChange,
  placeholder = 'Enter value',
  addLabel = 'Add item',
  emptyMessage = 'No items yet.',
}: StringListEditorProps) {
  const updateValue = (index: number, nextValue: string) => {
    onChange(values.map((value, itemIndex) => (itemIndex === index ? nextValue : value)));
  };

  const addValue = () => {
    onChange([...values, '']);
  };

  const removeValue = (index: number) => {
    onChange(values.filter((_, itemIndex) => itemIndex !== index));
  };

  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between gap-3">
        <h3 className="text-sm font-medium uppercase tracking-wide text-gray-500">
          {label}
        </h3>
        <SchedulerDsButton
          type="button"
          variant="secondary"
          size="sm"
          onClick={addValue}
        >
          <Plus className="size-4" />
          {addLabel}
        </SchedulerDsButton>
      </div>
      {values.length === 0 ? (
        <p className="text-sm text-gray-500">
          {emptyMessage}
        </p>
      ) : (
        <div className="space-y-3">
          {values.map((value, index) => (
            <div
              key={`${label}-${index}`}
              className="flex items-center gap-3"
            >
              <Input
                value={value}
                onChange={(event) => updateValue(index, event.target.value)}
                placeholder={placeholder}
                aria-label={`${label} ${index + 1}`}
              />
              <SchedulerDsButton
                type="button"
                variant="danger-ghost"
                size="sm"
                onClick={() => removeValue(index)}
                aria-label={`Remove ${label} ${index + 1}`}
              >
                <Trash2 className="size-4" />
              </SchedulerDsButton>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
